import { render, staticRenderFns } from "./ImagemProdutoDicas.vue?vue&type=template&id=89404a62&scoped=true&"
import script from "./ImagemProdutoDicas.vue?vue&type=script&lang=js&"
export * from "./ImagemProdutoDicas.vue?vue&type=script&lang=js&"
import style0 from "./ImagemProdutoDicas.vue?vue&type=style&index=0&id=89404a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89404a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
